export default __webpack_public_path__ + "static/page-loader-opt2-30a4ce026704cbd8d8b516468e64531a.gif";